import React, { useEffect, useState} from "react";
import { FormProvider, useForm } from "react-hook-form";
import { IFormUtilisateurBO } from "../../../models/interfaces/IFormUtilisateurBO";
import CpntForm from "../../../components/forms/CpntForm";
import CpntFormSection from "../../../components/forms/CpntFormSection";
import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import RadioInput from "../../../components/forms/RadioInput";
import { ModulesList, civiliteList, typeCompteList, validationMode } from "../../../config/helpers";
import TextInput from "../../../components/forms/TextInput";
import PhoneInputField from "../../../components/forms/PhoneInputField";

import { Button } from "react-bootstrap";
//import { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";

import SelectInput from "../../../components/forms/SelectInput";
import { ICompte } from "../../../models/interfaces/ICompte";
import { UtilisateurSchemaBO } from "../../../models/schema/UtilisateurSchemaBO";
import { useFetchSocietesQuery } from "../../../redux/slice/api/staticData";
import { useUpdateCompteBOModulesMutation } from "../../../redux/slice/api/BO/compteApi";
import { toast } from "react-toastify";
import { Type_Return_Message } from "../../../models/interfaces/IReturn_Parent";
import CheckboxInput from "../../../components/forms/CheckBoxInput";
import { useNavigate } from "react-router-dom";
import CpntFormSectionNavigation from "../../../components/forms/CpntFormSectionNavigation";


interface IProps {
    handleEnregistrer: (data: IFormUtilisateurBO) => void;
    Compte: ICompte | undefined;
    disableEmail: boolean;
    ReadOnlyServicePart:boolean;
    setCompte?: React.Dispatch<React.SetStateAction<ICompte | undefined>>;
    handleNomPrenom?: (value: string) => void;
  }


const UtilisateurInformationsPersonnelBO: React.FC<IProps> = ({handleEnregistrer,Compte,disableEmail,ReadOnlyServicePart,setCompte,handleNomPrenom}:IProps) => {

  const [activeModules, setActiveModules] = useState<number[]>([]);
  const navigate = useNavigate();
  const [
    BOCompteUpdateModules,
    {
    data : dataBOCompteUpdateModules,
    isSuccess: isSuccessUpdateModules,
    error: errorBOCompteUpdateModules,
    isLoading: isLoadingUpdateModules
  }] = useUpdateCompteBOModulesMutation();

  const handleToggle = async (moduleId:number) => {
    const updatedModules = activeModules.includes(moduleId)
      ? activeModules.filter((id) => id !== moduleId) // Désactiver le module
      : [...activeModules, moduleId]; // Activer le module

    setActiveModules(updatedModules); // Mise à jour locale
    await BOCompteUpdateModules(
      {
        IdCompte: Compte?.Id ?? -1,
        Modules: updatedModules
      }); // Envoi des modifications
      
  };

  const { data: societesList } = useFetchSocietesQuery();
    const formMethodsUtilisateur = useForm<IFormUtilisateurBO>({
        mode: "all",
        reValidateMode: "onChange",
        resolver: yupResolver(UtilisateurSchemaBO)
      });
        
      useEffect(() => {
        handleNomPrenom && handleNomPrenom((Compte?.Prenom ? Compte.Prenom : "") + (Compte?.Nom ? Compte.Nom + " " : ""));
        //if (Compte !== undefined) {
          setValueUtilisateur("IdCivilite", Compte?.IdCivilite ? Compte.IdCivilite : -1);
          setValueUtilisateur("Nom", Compte?.Nom ? Compte.Nom : "");
          setValueUtilisateur("Prenom", Compte?.Prenom ? Compte.Prenom : "");
          setValueUtilisateur("Email", Compte?.Email ? Compte.Email : "");
          setValueUtilisateur("Telephone", Compte?.Telephone ? Compte.Telephone : "");
          setValueUtilisateur("IdTypeCompte", Compte?.IdTypeCompte ? Compte.IdTypeCompte : -1);
          setValueUtilisateur("IdSociete", Compte?.IdSociete ? Compte.IdSociete : -1);
          setValueUtilisateur("RecevoirCommunications", Compte?.RecevoirCommunications ? Compte.RecevoirCommunications : false);
          setValueUtilisateur("RecevoirCommunicationsPartenaires", Compte?.RecevoirCommunicationsPartenaires ? Compte.RecevoirCommunicationsPartenaires : false)
          setActiveModules(Compte?.Modules ?? []);
        //}

      }, [Compte,societesList]) //societesList car requete et donc + long

      // setValue, setError, clearErrors,getValues
      const { handleSubmit:handleSubmitUtilisateur, setValue:setValueUtilisateur} = formMethodsUtilisateur;

      const onErrorUtilisateur = (errors: any) => {
        //
      };

 
       
    useEffect(() => {
      if (errorBOCompteUpdateModules !== undefined) {
          toast.warn("Les modifications n'ont pas été prises en compte");
          setActiveModules(Compte?.Modules ?? []); //initiale
        }
    }, [errorBOCompteUpdateModules])

    
      useEffect(() => {
        if (isSuccessUpdateModules && dataBOCompteUpdateModules?.Return_IdType_Message === Type_Return_Message.Validation) {
          toast.success("Les modifications ont bien été prises en compte.");
          if (dataBOCompteUpdateModules) {
            setActiveModules(dataBOCompteUpdateModules?.Compte?.Modules ?? []);
            setCompte && setCompte(dataBOCompteUpdateModules?.Compte);
          }
        } else if (isSuccessUpdateModules && dataBOCompteUpdateModules?.Return_IdType_Message === Type_Return_Message.Erreur) {
          if (dataBOCompteUpdateModules?.Return_Message !== "") {
            toast.warn(dataBOCompteUpdateModules?.Return_Message );
          } else {
            toast.warn("Les modifications n'ont pas été prises en compte");
          }
          setActiveModules(dataBOCompteUpdateModules?.Compte?.Modules ?? []);
          setCompte && setCompte(dataBOCompteUpdateModules?.Compte);
        }
      }, [isSuccessUpdateModules])


    return (
      <>
      <div className="row pt-3 pb-4">
        <div className="col col-md-10 offset-md-1 col-12 ">
              <FormProvider {...formMethodsUtilisateur}>
                  <form onSubmit={handleSubmitUtilisateur((data) => handleEnregistrer !== undefined && handleEnregistrer(data),onErrorUtilisateur)}>
                    <CpntForm>
                      <CpntFormSection pSectionLabel="Informations sur l’utilisateur">
                            <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12,6,6,6,6,6,6]}>
                              { 
                              <RadioInput
                              label="Civilité"
                              formName="IdCivilite"
                              ismandatory={true}
                              //defaultValue={watchedCivilite} 
                              options={civiliteList.map((civ) => {
                                return {
                                  id: civ.Id,
                                  name: civ.Libelle,
                                  value: civ.Id,
                                };
                              })}
                              // onchange={(e) => {
                              //  setValueUtilisateur("IdCivilite", Number(e.target.value));
                              // }}
                              />
                              }
                              {
                             <SelectInput
                                label="Type de compte"
                                formName="IdTypeCompte"
                                ismandatory={true}
                                options={typeCompteList.map((tc) => {
                                  return {
                                    Id: tc.Id,
                                    Libelle: tc.Libelle,
                                  };
                                })}

                              />
                              }
                            <SelectInput
                                label="Administrateur société"
                                formName="IdSociete"
                                ismandatory={true}
                                options={societesList?.Societes?.map((soc) => {
                                  return {
                                    Id: soc.Id,
                                    Libelle: soc.Libelle,
                                    //defaultChecked: civ.Id,
                                  };
                                })}
                              /> 
                              <TextInput
                                label="Nom"
                                formName="Nom"
                                validationStyle={validationMode.classic}
                                placeholder="Nom"
                                ismandatory={true}
                              />
                              <TextInput
                                label="Prénom"
                                formName="Prenom"
                                validationStyle={validationMode.classic}
                                placeholder="Prénom"
                                ismandatory={true}
                              />
                              <PhoneInputField
                                label="Téléphone"
                                formName="Telephone"
                                ismandatory={true}
                                placeholder="Numéro de téléphone"
                              />
                               <TextInput
                                label="Email"
                                formName="Email"
                                validationStyle={validationMode.classic}
                                placeholder="Email"
                                disabled={disableEmail}
                                popover="Attention ! Chaque changement d'email entraine un envoi d'email au client."
                              />
                               
                            </CpntFormSectionContainer>
                            <> {Compte !== null && Compte !== undefined && (
                              <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12,12]}>
                            <CheckboxInput
                                formName="RecevoirCommunications"
                                label={`J'accepte de recevoir les communications du portail "${process.env.REACT_APP_WEBSITE_TITLE}"`}
                                options={[
                                  {
                                    defaultChecked: dataBOCompteUpdateModules?.Compte?.RecevoirCommunications === true 
                                  },
                                ]}   
                                labelRight={true}   
                              />

                              <CheckboxInput
                                formName="RecevoirCommunicationsPartenaires"
                                label={`J'accepte de recevoir les communications des partenaires du portail "${process.env.REACT_APP_WEBSITE_TITLE}"`}
                                options={[
                                  {
                                    defaultChecked: dataBOCompteUpdateModules?.Compte?.RecevoirCommunicationsPartenaires === true 
                                  },
                                ]} 
                                labelRight={true}   
                              />
                            </CpntFormSectionContainer>
                            )}</>
                            
                            {disableEmail ? (
                                  <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[6,6]}>
                                    <Button
                                      onClick={() => navigate(`/admin/modifierutilisateuremailbo/${Compte?.Id}`)}
                                      className="btn-secondary btn btn-primary col-12"
                                    >
                                      Modifier votre email
                                    </Button>

                                    <Button type="submit" className="btn-secondary col-12">
                                      Enregistrer
                                    </Button>
                                  </CpntFormSectionContainer>
                                ) : (
                                  <CpntFormSectionNavigation>
                                    <Button type="submit" className="btn-secondary col-12">
                                      Enregistrer
                                    </Button>
                                  </CpntFormSectionNavigation>
                                )}
      
                      </CpntFormSection>
                    </CpntForm>
                  </form>
                </FormProvider>
          </div>
       </div>
       <div className="row pt-1 pb-5">
       <div className="col col-md-5 offset-md-1 col-12 "> 
         <div className="card form-card">
           <div className="card-body form-container text-start">
           <div className="d-flex"><p className="h6lpe me-4"><b>Les services de l&apos;utilisateur</b></p></div>
           {
           ReadOnlyServicePart ?
           ModulesList.map((mod) => (
             <><span>{mod.Libelle}</span> : <b>{ Compte?.Modules?.find(mid => mid === mod.Id) ? <i style={{padding: "0px 5px"}} className="text-green">Actif</i> : <i style={{padding: "0px 5px"}} className="text-redlight">Inactif</i>}</b><br/></>
             ))
         :
         ModulesList.map((mod) => (
           <div key={mod.Id} className="form-check form-switch mb-2">
           <input
            className={`form-check-input`} //${activeModules.includes(mod.Id) ? "bg-green":"bg-grey"}`}
             type="checkbox"
             id={`module-${mod.Id}`}
             checked={activeModules.includes(mod.Id)}
             onChange={() => handleToggle(mod.Id)}
             disabled={isLoadingUpdateModules} 
           />
           <label className="form-check-label" htmlFor={`module-${mod.Id}`}>
             <span>{mod.Libelle}</span>
           </label>
         </div>
       ))
         }
           </div>
         </div>
       </div>
       {/* <div className="col col-md-5 col-12 "> 
         <div className="card form-card">
           <div className="card-body form-container text-start">
           <div className="d-flex"><p className="h6lpe me-4"><b>L&apos;Administrateur de l&apos;organisation</b></p></div>

           </div>
         </div>
       </div> */}
     </div>
     </>
  );
};

export default UtilisateurInformationsPersonnelBO;

